import { Vue, Component } from 'vue-property-decorator';
import UserService from '@/services/user.service';
import TokenService from '@/services/token.service';
import { mutations, store } from '@/store/store';
import { UserDTO } from '@/models/UserDTO';
import InputText from '@/components/inputs/InputText/InputText';
import InputPassword from '@/components/inputs/InputPassword/InputPassword';
import ModalTemplate from '@/components/ModalTemplate/ModalTemplate';
import Terms from '@/components/Terms/Terms';
import { checkAcceptingTerms } from '@/config/app.config';
import { McsisRole } from '@/models/constants/McsisRole';

@Component({
  components: {
    InputText,
    InputPassword,
    ModalTemplate,
    Terms,
  },
})
export default class UserIdentification extends Vue {
  // Properties
  public errorMessage: string = '';
  public username: string = '';
  public password: string = '';
  public showModal: boolean = false;
  public rolePharmacist: string = McsisRole[McsisRole.Pharmacist];
  public roleDoctor: string = McsisRole[McsisRole.Doctor];
  private termsacceptancedate?: Date;

  // Lifecycle hook
  public mounted() {
    this.errorMessage = '';
  }

  // Methods

  /**
   * Logs the professionnal user in.
   */
  protected async login() {
    const username = this.username;
    const password = this.password;
    this.errorMessage = '';

    const loginResponse = await UserService.login(username, password)
      .then((res: UserDTO) => {
        if (TokenService.tokenExists()) {
          this.$emit('authenticated', true);
          mutations.setIsAuthenticated(true);

          return res.suName;
        }
      })
      .catch((error: any) => {
        if (error.response === undefined) {
          return;
        }

        switch (error.response.status) {
          case 401:
            this.errorMessage = 'errorMgs.loginPage.incorrectUserNameOrPassword'; // translation key
            break;
          case 403:
            this.errorMessage = 'errorMgs.loginPage.accountLocked'; // translation key
            break;
          default:
            this.errorMessage = 'errorMgs.loginPage.authenticationError'; // translation key
        }
      });

    if (loginResponse !== undefined && store.state.isAuthenticated) {
      await TokenService.generateXsrfToken()
        .then((data: any) => {
          TokenService.setXsrfTokenInHeader();

          if (checkAcceptingTerms(this.$route.params.screening)) {
            this.termsacceptancedate = this.$getAcceptanceDate();

            if (this.termsacceptancedate) {
              this.showModal = false;
              this.goToLogin(loginResponse);
            } else {
              this.showModal = true;
            }
          } else {
            this.showModal = false;
            this.goToLogin(loginResponse);
          }
        });
    }
  }

  protected async updateAcceptanceDate(username: string, newacceptancedate: Date) {
    await UserService.updateAcceptanceDate(username, newacceptancedate)
      .then((data: any) => {
        TokenService.refreshToken();
        // redirect to login participant in order to open the participant dossier
        this.goToLogin(null);
      });
  }

  protected termsAccepted() {
    this.showModal = false;
    this.updateAcceptanceDate(this.username, new Date());
  }

  protected termsRefused() {
    this.showModal = false;
    UserService.logout();
    // redirect to the pro-login page
    this.$router.push({
      name: 'pro-login',
      params: {
        screening: this.$route.params.screening,
      },
    });
  }

  protected goToLogin(suName: string|null): void {
    const su = suName !== null ? suName : this.$route.params.screening;
    this.$router.push({
      name: 'login',
      params: {
        screening: su,
      },
    });
  }

  protected getNbDaysDifference(date1: Date, date2: Date) {
    const timeDifference: number = Math.abs(date1.getTime() - date2.getTime());
    const daysDifference: number = Math.ceil(timeDifference / (1000 * 3600 * 24));
    return daysDifference;
  }
}
